/**
 * Eski sistem uyumluluk katmanı — getTranslate(code).
 *
 * Hook kullanamayan yerlerde (class bileşenler, modül fonksiyonları) çeviri
 * döndürür. Kaynak: I18nProvider'ın güncel tuttuğu paylaşılan in-memory sözlük
 * (Libs/i18n/dict). localStorage YOK — büyük blob senkron parse jank'ı yok.
 *
 * Not: Reaktif değildir (dil değişince otomatik re-render etmez); reaktif gerekirse
 * bileşende useT()/withT kullanılmalı. Sözlük, I18nProvider tarafından dil
 * değişiminde güncellenir, dolayısıyla değer her zaman aktif dile aittir.
 */
import { getDict } from '../i18n/dict';

const interpolate = (str, params) => {
    if (!params) return str;
    return str.replace(/\{\{(\w+)\}\}/g, (_, k) => (params[k] ?? `{{${k}}}`));
};

/** Çeviriyi in-memory sözlükten döndürür; karşılığı yoksa kodu placeholder olarak verir. */
export const getTranslate = (key, params) => {
    if (!key) return '';
    const val = getDict()[key];
    return typeof val === 'string' ? interpolate(val, params) : key;
};

export default getTranslate;
